
  <h2 mat-dialog-title>{{ title }}</h2>
  <mat-dialog-content>{{ body }}</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button
    [color]="confirmColor"
    (click)="confirmAction()" mat-dialog-close>{{ confirm }}</button>
    <button mat-button
    (click)="cancelAction()" mat-dialog-close>{{ cancel }}</button>
  </mat-dialog-actions>
    